import { useRouter } from "../router";
import { OrderList } from "./orders/OrderList";
import { OrderForm } from "./orders/OrderForm";
import { OrderDetail } from "./orders/OrderDetail";
import { Placeholder } from "../components/Placeholder";

export function Orders() {
  const { pathname } = useRouter();
  const sub = pathname.split("/").filter(Boolean).slice(2);

  if (sub.length === 0) return <OrderList />;
  if (sub[0] === "new") return <OrderForm />;

  const id = Number(sub[0]);
  if (!Number.isInteger(id) || id <= 0) return <NotFound />;
  if (sub.length === 1) return <OrderDetail id={id} />;

  return <NotFound />;
}

function NotFound() {
  return (
    <Placeholder
      eyebrow="Orders"
      title="Page not found."
      lede="That order doesn't exist."
      milestone="Back to orders"
    />
  );
}
